import { DEFAULT_LOCALES } from '@/translations/locales';

const numberFormatter = new Intl.NumberFormat(DEFAULT_LOCALES);

const formatNumber = (value) => numberFormatter.format(value || 0);

export default formatNumber;
